import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { MdSignalCellularAlt } from "react-icons/md";
import {
  FaMapPin,
  FaEdit,
  FaRegTrashAlt,
  FaMapMarkerAlt,
  FaRegCalendarAlt,
} from "react-icons/fa";
import "./MyList.css";
import axios from "../../../../../../api/axios";
import SyncLoader from "react-spinners/SyncLoader";

const MyList = () => {
  const decor = {
    textDecoration: "none",
  };
  const [products, setProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  // let url = `/api/show/visitor/property/${slug}`;

  let url = "/api/index/property";
  useEffect(() => {
    let config = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
    };
    setIsLoading(true);
    axios
      .get(url, config)
      .then((res) => {
        setProducts(res.data.data);
        console.log(res.data.data);
        setIsLoading(false);
      })
      .catch((err) => console.log(err));
  }, [url]);

  if (!products) {
    return (
      <div className="loading list-load">
        <SyncLoader color={"#098FD2"} size={60} />
      </div>
    );
  }

  return (
    <div>
      {isLoading ? (
        <div className="loading">
          <SyncLoader color={"#098FD2"} loading={isLoading} size={10} />
        </div>
      ) : (
        <div className="ml-container">
          {products.map((product) => {
            const {
              slug,
              property_name,
              property_image,
              property_price,
              state,
              street,
              data_added,
              property_category,
              lga,
              ammentities,
            } = product;
            console.log(product);

            return (
              <div key={slug}>
                <div className="">
                  <div className="ml-wrapper">
                    <div className="ml-cont">
                      <img src={property_image} alt="" />
                    </div>
                    <div className="ml-content">
                      <h3>{property_name}</h3>
                      <div className="ml-content-mini">
                        <FaMapMarkerAlt className="ml-map" />
                        <p>
                          {street} , {lga}
                        </p>
                      </div>
                      <div className="ml-content-mini">
                        <FaMapPin className="ml-map" />
                        <p>{state}</p>
                      </div>
                      <div className="mylist-price">₦ {property_price}</div>
                      <div className="ml-content-min">
                        For {property_category}
                      </div>

                      <div className="ml-content-min">{ammentities}</div>
                      <div className="ml-content-foot">
                        <div className="ml-foot-flex1">
                          <FaRegCalendarAlt />
                          <p>
                            <span>{data_added}</span>
                          </p>
                        </div>
                        <div className="ml-foot-flex2">
                          <Link
                            style={decor}
                            to={`/dashboard/property/${slug}/edit`}
                          >
                            <FaEdit className="ml-icon" />
                          </Link>
                          <MdSignalCellularAlt className="ml-icon" />
                          <FaRegTrashAlt className="ml-icon" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default MyList;
